import React from 'react';
import configuration from '../../constants/Configuration';
import { SVGContainer } from './SVGContainer';
import appParameters from '../utils/AppParameters';
import platformDetection from '../utils/PlatformDetection';

export const CanvasPrint = React.createClass({
    render() {
        const scaleProperties = this.props.scaleProperties;

        var svgContainerStyle = {
            backgroundColor: 'white',
            margin: 0,
            maxWidth: configuration.CANVAS_WIDTH,
            maxHeight: configuration.CANVAS_HEIGHT,
            float: 'none'
        };


        if (this.props.printTemplate == 0) {
            const scale = 0.7;
            const vGap = 9;

            if (this.props.index == 1)
                svgContainerStyle.marginTop = 0;
            else
                svgContainerStyle.marginTop = - (configuration.CANVAS_HEIGHT  - configuration.CANVAS_HEIGHT * scale) + vGap;

            svgContainerStyle.transform = `scale(${scale})`;
            svgContainerStyle.WebkitTransform = `scale(${scale})`;
        } else {
            var scale = 1.35;

            svgContainerStyle.transform = `scale(${scale}) rotate(${90}deg)`;
            svgContainerStyle.WebkitTransform = `scale(${scale}) rotate(${90}deg)`;

            if (platformDetection.isFirefox() == true)
                svgContainerStyle.paddingLeft = 245;
            else if (platformDetection.isEdge() == true) {
                svgContainerStyle.position = 'absolute';
                svgContainerStyle.marginTop = 335;
            } else
                svgContainerStyle.marginTop = 328;

            svgContainerStyle.maxWidth = undefined;
            svgContainerStyle.maxHeight = undefined;
        }

        return (
            <div id="svgContainer" style={svgContainerStyle}>
                <SVGContainer dispatch={this.props.dispatch} scaleProperties={scaleProperties} slideModelPrint={this.props.slideModel}/>
            </div>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/slide/CanvasPrint.js
 **/